import type { Schema, ConnectorConfig } from '../../services/api';
import type { UseMutationResult } from 'react-query';

export type SnackbarState = { severity: 'success' | 'error'; message: string } | null;

export const DEFAULT_NEW_SCHEMA = {
  tenantId: '',
  name: '',
  status: 'draft',
  createdBy: 'web-ui',
};

export const statusOptions = ['draft', 'active', 'archived', 'deprecated'];

/** Human-readable labels for status dropdown (Formats / Create Schema). Values sent to API stay lowercase. */
export const statusLabels: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  archived: 'Archived',
  deprecated: 'Deprecated',
};

/** Props shared by dialogs that need access to mutation state & form handlers */
export interface SchemaMutationContext {
  snackbar: SnackbarState;
  setSnackbar: React.Dispatch<React.SetStateAction<SnackbarState>>;
}

export type { Schema, ConnectorConfig };
